import { Upload } from 'antd';
import { RcFile } from 'antd/lib/upload/interface';
import Notification from 'components/ui/base/notification/Notification';
import { FileTypes } from 'utils/file-types';

export const CUSTOMER_FILE_ALLOWED_TYPES: FileTypes[] = [FileTypes.XLS, FileTypes.XLSX, FileTypes.CSV, FileTypes.PDF];
export const CUSTOMER_FILE_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export const validateCustomerFile = (file: RcFile) => {
    const fileExt = file.name.split('.').at(-1)?.toLowerCase();

    if (!fileExt || !CUSTOMER_FILE_ALLOWED_TYPES.map((type) => type.toLowerCase()).includes(fileExt)) {
        Notification({
            type: 'error',
            placement: 'top',
            messageTitle: 'File upload failed: File type not supported.',
            description: `The system only accepts files with the extensions ${CUSTOMER_FILE_ALLOWED_TYPES.map(
                (type) => `.${type.toLowerCase()}`
            ).join(', ')}. Please try again with a supported file.`,
        });
        return Upload.LIST_IGNORE;
    }

    if (file.size > CUSTOMER_FILE_MAX_SIZE_BYTES) {
        Notification({
            type: 'error',
            placement: 'top',
            messageTitle: 'File upload failed: File is too large.',
            description: `File ${file.name} exceeds the maximum allowed size of ${
                CUSTOMER_FILE_MAX_SIZE_BYTES / (1024 * 1024)
            }MB.`,
        });
        return Upload.LIST_IGNORE;
    }

    return true;
};
